
<footer class="condensed-footer">
  <p class="text-grey-text-subdued text-caption mb-8">
    <a class="condensed-footer__link text-grey-clickable underline" :href="footerLinks.accessibility" target="_blank"
      >Accessibility</a
    >
    <span aria-hidden="true"> • </span>
    <a class="condensed-footer__link text-grey-clickable underline" :href="footerLinks.trustAndSafety" target="_blank"
      >Trust&nbsp;&<span>&nbsp;</span>Safety&nbsp;Center</a
    >
    <span aria-hidden="true"> • </span>
    <a class="condensed-footer__link text-grey-clickable underline" :href="footerLinks.communityInclusion" target="_blank"
      >Community&nbsp;Inclusion</a
    >
    <span aria-hidden="true"> • </span>
    <a class="condensed-footer__link text-grey-clickable underline" :href="footerLinks.help" target="_blank">Help</a>
  </p>
  <p class="flex flex-col text-grey-text-subdued text-caption md:inline-block">
    <span>© {{ new Date().getFullYear() }} Sittercity Incorporated. All Rights Reserved. </span>
    <span
      >By using this site, you agree to the
      <a class="link-primary underline" :href="footerLinks.termsOfUse" target="_blank">Terms&nbsp;of&nbsp;Use</a>. See our
      <a class="link-primary underline" :href="footerLinks.privacy" target="_blank">Privacy&nbsp;Policy</a>. Make updates to
      <a class="link-primary underline" :href="footerLinks.doNotSellMyPersonalInformation" target="_blank"
        >Do&nbsp;Not&nbsp;Sell&nbsp;My&nbsp;Personal&nbsp;Information</a
      >.</span
    >
  </p>
</footer>
